import Pagination from '@mui/material/Pagination';
import React from 'react';

interface PaginationProps {
    totalCount: number;
    rowsPerPage: number;
    currentPage: number;
    onPageChange: (newPage: number) => void;
    sx?: any;
}

export const CustomPagination: React.FC<PaginationProps> = ({
    totalCount,
    rowsPerPage,
    currentPage,
    onPageChange,
    sx,
}) => {
    const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        onPageChange(newPage);
    };
    return (
        <Pagination
            sx={sx}
            count={Math.ceil(totalCount / rowsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
        />
    );
};
